import { gql } from '@apollo/client';

export const INSERT_LEAD = gql`
  mutation InsertLead($leadInput: SalesforceLeadInput!) {
    salesforceInsertLead(leadInput: $leadInput) {
      message
    }
  }
`;
